import { Navigate, useLocation } from "react-router-dom";

import { qcIncidentListPath, qcIncidentHomeFromPathname } from "@/lib/qc/qcIncidentNav";
import { useHubModuleHasAnyAccess } from "@/lib/useHubModuleWrite";

import { QcIncidentsPage } from "./QcIncidentsPage";

/**
 * Co-homed QC incidents: keep the user in a module they actually have.
 * Both `/manufacturing/qc-incidents` and `/quality/qc-incidents` accept Manufacturing or Quality.
 */
export function QcIncidentsCoHomePage() {
  const location = useLocation();
  const hasManufacturing = useHubModuleHasAnyAccess("manufacturing");
  const hasQuality = useHubModuleHasAnyAccess("quality");
  const currentHome = qcIncidentHomeFromPathname(location.pathname);
  const hasCurrentHome = currentHome === "quality" ? hasQuality : hasManufacturing;
  const otherHome = currentHome === "quality" ? "manufacturing" : "quality";
  const hasOtherHome = otherHome === "quality" ? hasQuality : hasManufacturing;
  if (!hasCurrentHome && hasOtherHome) {
    return <Navigate to={`${qcIncidentListPath(otherHome)}${location.search}`} replace />;
  }
  return <QcIncidentsPage />;
}
